import React from 'react';
import { TabsContent } from '@/components/ui/tabs';
import { WorkingHoursConfigurationCompact } from '@/components/settings/WorkingHoursConfigurationCompact';
import { TabAccessAlerts } from './TabAccessAlerts';
import type { SettingsFormState } from '../hooks/useSettingsFormState';
import type { WorkingProfile, PolicyViolationSettings } from '@/types/timesheetSettings';

interface WorkingHoursTabProps {
  form: SettingsFormState;
  workingProfile: WorkingProfile;
  policyEnforcement: PolicyViolationSettings;
  canEditWorkingHours: boolean;
  canManagePolicySettings: boolean;
  onBeforeSync: () => Promise<void>;
}

export const WorkingHoursTab: React.FC<WorkingHoursTabProps> = ({
  form,
  workingProfile,
  policyEnforcement,
  canEditWorkingHours,
  canManagePolicySettings,
  onBeforeSync,
}) => {
  const {
    policyLimits, approvalScreen,
    publicHolidayCountryDefault, publicHolidayProject, publicHolidayCostCentre,
    tabsWithChanges,
    handleWorkingProfileChange, handlePolicyEnforcementChange, handlePolicyLimitsChange,
    handleApprovalScreenChange, handlePublicHolidayCountryChange,
    handlePublicHolidayProjectChange, handlePublicHolidayCostCentreChange,
  } = form;

  return (
    <TabsContent value="working-hours" className="space-y-6">
      <TabAccessAlerts
        canEdit={canEditWorkingHours}
        hasChanges={tabsWithChanges.has('working-hours')}
        viewOnlyText="You have view-only access to Working Hours & Policies. Contact your administrator to request edit access."
        unsavedText={'You have unsaved changes. Click "Save Settings" to apply your changes.'}
      />

      <WorkingHoursConfigurationCompact
        workingProfile={workingProfile}
        policyEnforcement={policyEnforcement}
        policyLimits={policyLimits}
        approvalScreen={approvalScreen}
        publicHolidayCountryDefault={publicHolidayCountryDefault}
        publicHolidayProject={publicHolidayProject}
        publicHolidayCostCentre={publicHolidayCostCentre}
        canManagePolicySettings={canManagePolicySettings}
        onWorkingProfileChange={handleWorkingProfileChange}
        onPolicyEnforcementChange={handlePolicyEnforcementChange}
        onPolicyLimitsChange={handlePolicyLimitsChange}
        onApprovalScreenChange={handleApprovalScreenChange}
        onPublicHolidayCountryChange={handlePublicHolidayCountryChange}
        onPublicHolidayProjectChange={handlePublicHolidayProjectChange}
        onPublicHolidayCostCentreChange={handlePublicHolidayCostCentreChange}
        onBeforeSync={onBeforeSync}
      />
    </TabsContent>
  );
};
